import styled from 'styled-components'

export const LGPDStyle = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small
  }};
  border: ${({ theme }) => {
    return theme.border
  }};
  background-color: ${({ theme }) => {
    return theme.colors.trueWhite
  }};
  p {
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    color: ${({ theme }) => {
      return theme.colors.black
    }};
    margin: 0 0 5px 0;
  }
  button {
    padding: 2px;
    border: none;
    font-family: 'Ubuntu', sans-serif;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    color: ${({ theme }) =>
      ({ isVerify }: { isVerify: boolean }) => {
        if (isVerify) {
          return theme.colors.trueWhite
        } else {
          return theme.colors.black
        }
      }};
    background-color: ${({ theme }) =>
      ({ isVerify }: { isVerify: boolean }) => {
        if (isVerify) {
          return theme.colors.success
        } else {
          return theme.colors.alert
        }
      }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) =>
        ({ isVerify }: { isVerify: boolean }) => {
          if (isVerify) {
            return theme.colors.darkSuccess
          } else {
            return theme.colors.darkAlert
          }
        }};
    }
  }

  @media screen and (max-width: 720px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
    }
  }

  @media screen and (max-width: 480px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
    }
  }
`
